

// ------------ version 2 ------------
import { useState } from 'react';
import { BiCheck } from 'react-icons/bi';
import { PaystackButton } from 'react-paystack';

const usePayment = (email, apiKey, amount, onSuccess, onClose) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [paymentSuccess, setPaymentSuccess] = useState(false)

  const handlePaystackSuccessAction = (reference) => {
    setLoading(false);
    onSuccess(reference)
    setPaymentSuccess(true)
    // verifyPayment();
  };

  const handlePaystackCloseAction = () => {
    setLoading(false);
    onClose();
  };

  const initiatePayment = () => {
    setLoading(true);
    setError(null);
  };

  const PaymentComponent = () => (
    <PaystackButton
      email={email}
      amount={amount * 100} 
      publicKey={apiKey}
      text={paymentSuccess ? <BiCheck/> : 'PayNow'}
      onSuccess={handlePaystackSuccessAction}
      onClose={handlePaystackCloseAction}
    />
  );

  return {
    PaymentComponent,
    initiatePayment,
    loading,
    error,
  };
};

export default usePayment;







// import { useState, useEffect } from 'react';
// import PaystackPop from '@paystack/inline-js';

// const usePayment = (email, publicKey, amount, onSuccess, onClose) => {
//   const [error, setError] = useState(null);
//   const [isReady, setIsReady] = useState(false);

//   useEffect(() => {
//     if (!email || !publicKey || !amount || !onSuccess || !onClose) {
//       setError(new Error('Missing required payment parameters'));
//       return;
//     }

//     let paystack;
//     try {
//       paystack = new PaystackPop();
//       paystack.newTransaction({
//         key: publicKey,
//         email,
//         amount: parseInt(amount) * 100, // Convert to kobo
//         onSuccess: (response) => {
//           onSuccess(response);
//         },
//         onClose: () => {
//           onClose();
//         },
//       });
//       setIsReady(true);
//     } catch (err) {
//       setError(err);
//       console.error('Paystack initialization error:', err);
//     }

//     return () => {
//       // Cleanup if needed
//     };
//   }, [email, publicKey, amount, onSuccess, onClose]);

//   const initiatePayment = () => {
//     if (!isReady) {
//       setError(new Error('Payment not ready'));
//       return;
//     }
//     if (typeof window.PaystackPop !== 'undefined') {
//       window.PaystackPop().openIframe(); // Trigger the popup
//     } else {
//       setError(new Error('Paystack library not loaded'));
//     }
//   };

//   return { initiatePayment, error };
// };

// export default usePayment;